// Copertine news in /public/news: usa la versione WebP leggera quando disponibile.
const NEWS_WEBP = new Set(["news-1","news-10","news-11","news-12","news-13","news-14","news-15","news-16","news-17","news-18","news-2","news-3","news-4","news-5","news-6","news-7","news-8","news-9"]);
export function optImg(url) {
  if (typeof url !== "string") return url;
  const m = url.match(/^\/news\/([^/?]+)\.(jpe?g|png)$/i);
  return m && NEWS_WEBP.has(m[1]) ? `/news/${m[1]}.webp` : url;
}
